<script lang="ts">
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  export let currentStep: number = -1;
</script>

<ul class="fizz-progress-list fizz-margin-auto" style="max-width: 514px;">
  <li
    data-step="1 of 3"
    class={currentStep == 1 ? "fizz-is-active" : currentStep > 1 ? "fizz-is-complete" : ""}
  >
    <UIRouterLink
      stateName="layout.signedIn.details"
      style={currentStep < 1 ? "pointer-events: none" : ""}
    >
      Business Details
    </UIRouterLink>
  </li>
  <li
    data-step="2 of 3"
    class={currentStep == 2 ? "fizz-is-active" : currentStep > 2 ? "fizz-is-complete" : ""}
  >
    <UIRouterLink
      stateName="layout.signedIn.distributors"
      style={currentStep < 2 ? "pointer-events: none" : ""}
    >
      Your Distributors
    </UIRouterLink>
  </li>
  <li
    data-step="3 of 3"
    class={currentStep == 3 ? "fizz-is-active" : currentStep > 3 ? "fizz-is-complete" : ""}
  >
    <UIRouterLink
      stateName="layout.signedIn.salesRep"
      style={currentStep < 3 ? "pointer-events: none" : ""}
    >
      Your Sales Reps
    </UIRouterLink>
  </li>
</ul>
<p class="fizz-text-right fizz-text-small">
  <strong
    ><a href="https://support.provi.com" target="_blank" rel="noopener noreferrer">Help</a></strong
  >
</p>
